exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Step\\.module__step___2kufn {\n  margin-bottom: 20px;\n}\n\n.Step\\.module__stepImg___2Jrhy {\n  max-height: 180px;\n  margin-bottom: 40px;\n}\n\n.Step\\.module__stepTitle___25uMh {\n  color: var(--ap-pink);\n  font-size: 1.3rem;\n  font-weight: bold;\n}\n\n.Step\\.module__stepBody___1Tu3p {\n  color: #666;\n  font-size: 1.1rem;\n  margin: 0 40px;\n  max-width: 295px;\n}\n", ""]);
// Exports
exports.locals = {
	"step": "Step.module__step___2kufn",
	"stepImg": "Step.module__stepImg___2Jrhy",
	"stepTitle": "Step.module__stepTitle___25uMh",
	"stepBody": "Step.module__stepBody___1Tu3p"
};